import { QuestionCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Popconfirm } from "antd";

interface IProps {
  loading?: boolean;
  children?: React.ReactNode;
  onConfirm?:
    | ((e?: React.MouseEvent<HTMLElement, MouseEvent> | undefined) => void)
    | undefined;
}

export const SharedPopconfirm: React.FC<IProps> = ({
  loading,
  children,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Popconfirm
      title={t("AreYouSure")}
      okText={t("YesAnswer")}
      cancelText={t("NoAnswer")}
      onConfirm={onConfirm}
      okButtonProps={{ loading, disabled: loading }}
      icon={<QuestionCircleOutlined style={{ color: "#f44336" }} />}
    >
      {children}
    </Popconfirm>
  );
};
